import { render, staticRenderFns } from "./PreciosProductos.vue?vue&type=template&id=4cfc4976&"
import script from "./PreciosProductos.vue?vue&type=script&lang=js&"
export * from "./PreciosProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports